import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiMessagingHelperService } from './messaging-helper.service';

@Injectable({ providedIn: 'root' })
export class ApiMessagingService {
  constructor(
    public hpr: ApiMessagingHelperService,
    private _api: ApiService,
  ) {}

  getDiscussion(data: any = {}) {
    return this._api.post('messaging-discussion/get', data);
  }

  listDiscussion(data: any = {}) {
    return this._api.post('messaging-discussion/list', data);
  }

  removeDiscussion(id: number) {
    return this._api.post('messaging-discussion/remove/id/' + id);
  }

  setDiscussionViewed(data: any = {}) {
    return this._api.post('messaging-discussion/set-viewed', data);
  }

  removeMessage(id: number) {
    return this._api.post('messaging-message/remove/id/' + id);
  }

  muteUser(data: any = {}) {
    return this._api.post('messaging-discussion/mute-user', data);
  }

  unmuteUser(data: any = {}) {
    return this._api.post('messaging-discussion/unmute-user', data);
  }

  listMessage(data: any = {}) {
    return this._api.post('messaging-message/list', data);
  }

  createMessage(data: any) {
    return this._api.post('messaging-message/create', data);
  }

  updateMessage(data: any) {
    return this._api.post('messaging-message/update', data);
  }

  pull(data: any) {
    return this._api.post('messaging/pull', data, { edge: true });
  }
}
